export default {"src":"/_next/static/media/in_bold.d5bfef3a.svg","height":24,"width":24};